import { schema } from 'normalizr';

export const ENTITY_FINANCING_DETAILS = 'financingDetails';
export const ENTITY_FINANCING_DETAILS_LIST = 'financingDetailsList';

export const financingDetailsSchema = new schema.Entity(
  ENTITY_FINANCING_DETAILS,
  {},
  { idAttribute: (value) => value.firm_name },
);

export const financingDetailsListSchema = new schema.Entity(
  ENTITY_FINANCING_DETAILS_LIST,
  { data: [financingDetailsSchema] },
  { idAttribute: () => 'list' },
);
